import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerProfileFollowerGrowth.graphql';
import { Query, QueryinfluencerProfileFollowerGrowthArgs } from '../../__generated__/globalTypes';

export const useInfluencerProfileFollowerGrowthQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerProfileFollowerGrowthArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerProfileFollowerGrowthArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerProfileFollowerGrowthLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerProfileFollowerGrowthArgs>
): QueryResult<Query, QueryinfluencerProfileFollowerGrowthArgs> & {
  getInfluencerProfileFollowerGrowth: LazyQueryExecFunction<Query, QueryinfluencerProfileFollowerGrowthArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerProfileFollowerGrowth, result] = useLazyQuery<Query, QueryinfluencerProfileFollowerGrowthArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getInfluencerProfileFollowerGrowth, ...result };
};

export const useInfluencerProfileFollowerGrowthPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerProfileFollowerGrowth = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerProfileFollowerGrowthArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerProfileFollowerGrowthArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerProfileFollowerGrowth };
};
// Suspense Query Hooks
export const useInfluencerProfileFollowerGrowthSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerProfileFollowerGrowthArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerProfileFollowerGrowthArgs>(QUERY, {
    ...options
  });

  return result;
};
